<template lang="html">

 <div class="contacto--view contacto">


   <intro></intro>

   <section class="at-cliente pad-sec">
    <div class="container flex wrap">
      <div id="solicita-catalogo">
        <formulario :reason="$route.meta.previousRoute"></formulario>
      </div>
    </div>
  </section>
  
  <section class="sucursales-info">
    <div class="direccion container flex row-reserve justify-start">
      <div class="col-50">
        <div class="direcciones--container">
          <div class="scroller sedes">

            <div class="element">
                <h3 class="title title-26">{{ $t(`contacto.delegaciones.${$t('contacto.id')}.titulo`) }}</h3>
                <p>{{ direccion }}</p>
                <p>{{ telefono}}</p>
                <p v-html="this.email"></p>
            </div>

          </div>

        </div>
        <h3 class="title title-26">{{$t('contacto.sucursales')}}</h3>
        <p class="enlaces_delegaciones">
          <span v-for="(e, key) in $t('contacto.delegaciones')" :key="key" class="js-show-pais" @click="setMapa(key)" :data="key">{{e.nombre}}</span>
        </p>  
      </div>
    </div>
  </section>
  <section class="mapa">

    <GmapMap :center="!coords ? $t('contacto.coords') : coords " :zoom="15" id="map">
      <GmapMarker :position="!coords ? $t('contacto.coords') : coords"/>
    </GmapMap>
    
    
  </section>


  <section class="work-us sec-foto metal">
    <img class="w-100" src="/static/img/bkg/bkg-work-us.webp" :alt="$t('contacto.alt_images.trabajar_ajusa')">
    <div class="container waypoints flex row-reserve justify-start" data="fadeInLeft">
      <div class="col-50 container-text">
        <router-link :to="{ name: 'trabaja_con_nosotros'}"></router-link>
        <h3 class="title title-52">{{$t('enlaces.textos.trabaja_con_nosotros')}}</h3>
        <p>{{$t('trabaja_con_nosotros.texto')}}</p>
        <p class="go">{{$t('trabaja_con_nosotros.boton')}}<i class="fa-sharp fa-solid fa-arrow-right-long" aria-hidden="true"></i></p>
      </div>
    </div>
  </section>

  <otras-secciones :data="['sala_prensa','actualidad']"></otras-secciones>


</div>


</template>

<script lang="js">
    import Intro from '@/components/view-parts/intros/contacto';
    import Formulario from '@/components/view-parts/contacto-parts/formulario';

    import Otras_Secciones from '@/components/parts/acceso-a-secciones';

    import Vue from 'vue'
    import * as VueGoogleMaps from 'vue2-google-maps'
    import { i18n } from '@/i18n'
    import { mapGetters } from 'vuex'

    Vue.use(VueGoogleMaps, {
        load: {
            key: 'AIzaSyAttpTK5iehbKQax7nKCYv37uyRtuGoYWk',
        }
    })


    export default {
        name: 'contacto',
        props: [],
        created() {
            document.head.querySelector("[property='og:title']").content = "Contacto";
        },
        mounted() {
            if (this.$route.meta.previousRoute == "catalogo") {
                let pos = $(".at-cliente").position().top;
                $('body,html').animate({
                    scrollTop: pos
                }, 800);

            }

            this.setMapa(i18n.t('contacto.id'))
        },
        data() {
            return {
                site_coords: {
                    espana: {
                        lat: 39.0034405,
                        lng: -1.8193903999999748
                    },
                    rusia: {
                        lat: 55.526836777138584,
                        lng: 37.448515283993856
                    },
                    uk: {
                        lat: 52.71716135415642,
                        lng: - 2.46484123138884
                    },
                    mexico: {
                        lat: 19.443061205605765,
                        lng: -99.19093869999995
                    },
                    brasil: {
                        lat: -23.515094656909923,
                        lng: -46.744552150000004
                    },
                    usa: {
                        lat: 25.74785930888482,
                        lng: -80.26214470369948
                    },
                    francia: {
                        lat: 45.8049383,
                        lng: 1.2731825
                    },
                },
                coords: {
                    lat: 39.0034405,
                    lng: -1.8193903999999748
                },
                direccion: null,
                telefono: null,
                email: null
            }
        },
        methods: {
            setMapa: function (value) {
                let move = $(".direcciones--container").height();
                let position = $(`.element[data="${value}"]`).index() * move;
                $(".scroller.sedes").attr('style', `transform:translateY(-${position}px)`);
                this.coords = this.site_coords[value];
                this.direccion = i18n.t(`contacto.delegaciones.${value}.direccion`);
                this.telefono = i18n.t(`contacto.delegaciones.${value}.telefono`);
                this.email = i18n.t(`contacto.delegaciones.${value}.email`);
            }
        },
        computed: {
            ...mapGetters({
                lang: 'getLanguage'
            })
        },
        watch: {
            'lang'() {
                this.setMapa(i18n.t('contacto.id'))
            }
        },
        components: {
            'intro': Intro,
            'formulario': Formulario,
            'otras-secciones': Otras_Secciones
        }
    }
</script>

<style scoped>
    .element {
        height: 210px;
        display: -webkit-flex;
        display: -moz-flex;
        display: -ms-flex;
        display: -o-flex;
        display: flex;
        -webkit-flex-direction: column;
        -moz-flex-direction: column;
        -ms-flex-direction: column;
        -o-flex-direction: column;
        flex-direction: column;
        justify-content: center;
        -webkit-justify-content: center;
    }
    
    .element h3 {
        margin-top: 0;
    }
    
    .scroller {
        will-change: transform;
        transition: .4s;
    }
    
    .direcciones--container {
        height: 210px;
        overflow: hidden;
    }
    
    .enlaces_delegaciones span {
        padding-right: 10px;
        margin-right: 10px;
        border-right: 1px solid white;
    }
    
    .enlaces_delegaciones span:last-of-type {
        border-right: none;
        margin-right: 0;
        padding-right: 0;
    }
    
    .js-show-pais {
        cursor: pointer;
    }
    
    #solicita-catalogo {
        width: 100%;
    }
    
    .sucursales-info {
        background-color: #e6ecf1;
        color: white;
        padding: 30px 0;
        padding-top: 60px;
        position: relative;
    }
    
    .direccion .col-50 {
        width: 100%;
        text-align: left;
    }
    
    .sucursales-info .justify-start {
        background-color: #054279;
        max-width: 620px;
        padding: 30px;
        text-align: left;
        position: absolute;
        left: 50px;
        z-index: 6;
        top: 0px;
    }
    
    @media only screen and (max-width: 1024px) {
        .sucursales-info .justify-start {
            background-color: #054279;
            max-width: 100%;
            padding: 30px;
            text-align: left;
            position: relative;
            left: 0;
            z-index: 6;
            top: 0px;
        }
        .sucursales-info {
            padding: 0;
        }
    }
    
    @media screen and (max-width: 760px) {
        .enlaces_delegaciones span {
            width: 100%;
            display: inline-block;
            border-right: 0;
        }
        .direcciones--container {
            height: 260px;
        }
        .element {
            height: 260px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/views/contacto.vue